import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Preloader = ({ message = "Carregando...", fullScreen = false }) => {
    if (fullScreen) {
        return (
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    zIndex: 9999,
                }}
            >
                <CircularProgress size={50} sx={{ color: '#20ac9c' }} />
                {message && (
                    <Typography variant="h6" sx={{ mt: 2, color: '#555', fontWeight: 500 }}>
                        {message}
                    </Typography>
                )}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 4,
                width: '100%',
                minHeight: '200px', // Garante uma altura mínima para não colapsar
                flex: 1
            }}
        >
            <CircularProgress sx={{ color: '#20ac9c' }} />
            {message && (
                <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export default Preloader;
